import { useEffect, useState } from "react";
import { api, fmtCurrency, fmtDate } from "../../lib/api";
import MobileHeader from "../../components/MobileHeader";
import { Plus, ShoppingCart } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { toast } from "sonner";

export default function BusinessSales() {
    const [items, setItems] = useState([]);
    const [products, setProducts] = useState([]);
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ product_id: "", qty: 1, payment_method: "cash" });

    const refresh = () => {
        api.get("/business/sales").then((r) => setItems(r.data));
        api.get("/business/products").then((r) => setProducts(r.data));
    };
    useEffect(() => { refresh(); }, []);

    const submit = async () => {
        const p = products.find((x) => x.id === form.product_id);
        if (!p) return toast.error("Pick a product");
        await api.post("/business/sales", {
            items: [{ product_id: p.id, qty: parseInt(form.qty || 1, 10), price: p.price, name: p.name }],
            payment_method: form.payment_method,
        });
        setOpen(false); refresh(); toast.success("Sale recorded");
    };

    return (
        <div data-testid="sales-page">
            <MobileHeader title="POS Sales" backTo="/business/more" variant="blue" />
            <div className="px-5 -mt-6 pb-4 space-y-3">
                <div className="bg-white rounded-2xl border border-slate-200/60 overflow-hidden product-shadow">
                    {items.length === 0 && <div className="p-8 text-center text-sm text-slate-500">No sales yet</div>}
                    {items.slice(0, 30).map((s, i) => (
                        <div key={s.id} className={`flex items-center gap-3 px-4 py-3.5 ${i !== items.length - 1 ? "border-b border-slate-100" : ""}`} data-testid={`sale-${s.id}`}>
                            <div className="size-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center"><ShoppingCart size={18} /></div>
                            <div className="flex-1">
                                <div className="font-semibold text-sm">{s.items?.[0]?.name || "Sale"}</div>
                                <div className="text-xs text-slate-500 capitalize">{s.payment_method} · {fmtDate(s.created_at)}</div>
                            </div>
                            <div className="font-display font-bold text-sm">{fmtCurrency(s.total)}</div>
                        </div>
                    ))}
                </div>
                <Button onClick={() => setOpen(true)} className="w-full h-12 rounded-xl bg-[#00D084]" data-testid="record-sale-btn"><Plus size={18} /> Record Sale</Button>
            </div>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="rounded-2xl">
                    <DialogHeader><DialogTitle>Record Sale</DialogTitle></DialogHeader>
                    <div className="space-y-3">
                        <div>
                            <Label>Product</Label>
                            <Select value={form.product_id} onValueChange={(v) => setForm((f) => ({ ...f, product_id: v }))}>
                                <SelectTrigger className="mt-1.5 h-11 rounded-xl" data-testid="sale-product-select"><SelectValue placeholder="Pick a product" /></SelectTrigger>
                                <SelectContent>
                                    {products.map((p) => <SelectItem key={p.id} value={p.id}>{p.name} · {fmtCurrency(p.price)}</SelectItem>)}
                                </SelectContent>
                            </Select>
                        </div>
                        <div><Label>Quantity</Label><Input type="number" value={form.qty} onChange={(e) => setForm((f) => ({ ...f, qty: e.target.value }))} className="mt-1.5 h-11 rounded-xl" data-testid="sale-qty" /></div>
                        <div>
                            <Label>Payment</Label>
                            <Select value={form.payment_method} onValueChange={(v) => setForm((f) => ({ ...f, payment_method: v }))}>
                                <SelectTrigger className="mt-1.5 h-11 rounded-xl" data-testid="sale-pm-select"><SelectValue /></SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="cash">Cash</SelectItem>
                                    <SelectItem value="transfer">Bank Transfer</SelectItem>
                                    <SelectItem value="wallet">Wallet</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>
                        <Button onClick={submit} className="w-full h-11 rounded-xl bg-[#0A1930]" data-testid="sale-submit">Record</Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}
